import { render } from "./CourseDiscovery.vue?vue&type=template&id=ea21c750&scoped=true"
import script from "./CourseDiscovery.vue?vue&type=script&lang=js"
export * from "./CourseDiscovery.vue?vue&type=script&lang=js"

import "./CourseDiscovery.vue?vue&type=style&index=0&id=ea21c750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea21c750"]])

export default __exports__